  const CHECKBOX_IDS = ['cart-terms-agreement', 'cart-terms-agreement-page'];
  const ERROR_SELECTOR = '.cart__terms-error';

  const CHECKOUT_SELECTORS = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'button#checkout',
    '.shopify-payment-button button',
    '[data-shopify="payment-button"] button',
    'shopify-paypal-button',
    'shopify-accelerated-checkout-cart',
    '.additional-checkout-buttons button',
    '.dynamic-checkout__content button',
    '.btn-view-cart'
  ].join(',');

  // Find the nearest checkbox to the clicked button (in case of multiple)
  const findCheckbox = (referenceEl) => {
    // Look for any checkbox with our ID pattern within the same form/section
    for (const id of CHECKBOX_IDS) {
      const cb = document.getElementById(id);
      if (cb && cb.offsetParent !== null) return cb; // visible one
    }
    // Fallback: any visible one
    return document.querySelector(`#${CHECKBOX_IDS.join(', #')}`);
  };

  const getVisibleError = () => {
    const errors = document.querySelectorAll(ERROR_SELECTOR);
    // Return the one inside the same container as the visible checkbox
    const checkbox = findCheckbox();
    if (!checkbox) return null;
    const container = checkbox.closest('.cart__terms');
    return container?.querySelector(ERROR_SELECTOR) || errors[0];
  };

  const showError = () => {
    const el = getVisibleError();
    if (!el) return;
    el.classList.remove('is-hidden');
    el.scrollIntoView({ block: 'center', behavior: 'smooth' });
  };

  const hideAllErrors = () => {
    document.querySelectorAll(ERROR_SELECTOR).forEach(el => el.classList.add('is-hidden'));
  };

  const blockIfUnchecked = (e) => {
    const checkbox = findCheckbox();
    if (!checkbox) return false;
    if (checkbox.checked) return false;

    e.preventDefault();
    e.stopImmediatePropagation();
    showError();
    setTimeout(() => checkbox.focus(), 200);
    return true;
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest(CHECKOUT_SELECTORS)) blockIfUnchecked(e);
  }, true);

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form.id === 'cart-form' ||
        (form.action?.includes('/cart') && !form.action?.includes('/cart/add')) ||
        form.action?.includes('/checkout')) {
      blockIfUnchecked(e);
    }
  }, true);

  document.addEventListener('change', (e) => {
    if (CHECKBOX_IDS.includes(e.target?.id) && e.target.checked) {
      hideAllErrors();
    }
  });
